<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:30:57
 * @LastEditTime: 2025-08-31 23:58:56
-->
<template>
  <div class="precisePost">
    <div class="title">
      <van-button type="info" block @click="show = true">标准筛选</van-button>
    </div>

    <van-action-sheet v-model="show">
      <div class="content-action">
        <van-field v-model="form.major[0]" label="专业" placeholder="请输入专业" />
        <!-- <van-field v-model="form.background" label="学历" placeholder="请输入学历" /> -->
        <van-field v-model="form.companyName" label="企业" placeholder="请输入企业" />


        <div class="item">
          <p>学历</p>
          <ul>
            <li v-for="(item, index) in educationNewList" :key="index"
              @click="handle('background', item, index, 'educationNewListIndex')"
              :class="index == educationNewListIndex ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>


        <div class="item">
          <p>毕业届</p>
          <ul>
            <li v-for="(item, index) in graduationYear" :key="index"
              @click="handle('graduationYear', item, index, 'graduationYearIndex')"
              :class="index == graduationYearIndex ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>

        <div class="item">
          <p>公司类型</p>
          <ul >
            <li v-for="(item, index) in companyType" :key="index"
              @click="handle('companyType', item, index, 'companyTypeIndex')"
              :class="index == companyTypeIndex ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>

        <div class="item">
          <p>岗位类型</p>
          <ul>
            <li v-for="(item, index) in postType" :key="index" @click="handle('postType', item, index, 'postTypeIndex')"
              :class="index == postTypeIndex ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>

        <div class="item">
          <p>岗位状态</p>
          <ul>
            <li v-for="(item, index) in postStatus" :key="index"
              @click="handle('postStatus', item, index, 'postStatusIndex')"
              :class="index == postStatusIndex ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div>

        <!-- <div class="item">
          <p>岗位类别</p>
          <ul>
            <li v-for="(item, index) in postType" :key="index"
              @click="handle('postType1Index', item, index, 'postType1Index')"
              :class="index == postType1Index ? 'active' : ''">
              {{ item.text }}
            </li>
          </ul>
        </div> -->

        <van-field v-model="form.city[0]" label="地址" placeholder="请输入地址" />
      </div>
    </van-action-sheet>

    <listPost type="intelligencePost" :form="form" :key="key"></listPost>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" @click="toUrl('tool')">首页</van-tabbar-item>
      <van-tabbar-item icon="orders-o" @click="toUrl('/enterpriseList')">企业名录</van-tabbar-item>
      <van-tabbar-item icon="apps-o">标准筛岗</van-tabbar-item>
      <van-tabbar-item icon="bookmark-o" @click="toUrl('precisePost')">智能筛岗</van-tabbar-item>
      <!-- <van-tabbar-item icon="setting-o" @click="toUrl()"="/home">重点标识</van-tabbar-item> -->
      <van-tabbar-item icon="manager-o" @click="toUrl('myCollect')">我的收藏</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { Tabbar, TabbarItem } from 'vant';
Vue.use(Tabbar);
Vue.use(TabbarItem);
import tools from "@/libs/utils";
import { postList, getPostFilter, getDictType } from "@/api/xicaiquan";
import { Button, ActionSheet, Field, Tag } from "vant";
Vue.use(Button);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(Tag);
import listPost from "./component/listPost.vue";
export default {
  name: "precisePost",
  data() {
    return {
      show: false,
      active: 2,
      key: '',
      form: {
        major: [],
        background: [],
        companyName: "",
        graduationYear: [],
        companyType: [],
        postType: [],
        // postType1Index: [],
        city: [],
        postStatus: "",
        companyNameExcludeFilterList: [],
        postNameExcludeFilterList: []


      },
      graduationYear: [], // 毕业届
      companyType: [], // 企业类型
      postType: [], // 岗位类型
      postStatus: [], // 岗位状态
      educationNewList: [], // 学历
      byjIndex: 0,
      educationNewListIndex: 5,
      graduationYearIndex: 2,
      companyTypeIndex: 10,
      postTypeIndex: 0,
      postStatusIndex: 1,
      // postType1Index: 0,

    };
  },
  created() {
    if (!tools.getToken1()) {
      this.$router.replace({ path: "/login" });
    }

    this.getDictType("company_type", "companyType", (data) => this.form.companyType.push(data[10].value))
    this.getDictType("graduation_year", "graduationYear", (data) => this.form.graduationYear.push(data[2].value))
    this.getDictType("post_type", "postType", (data) => this.form.postType.push(data[0].value))
    this.getDictType("education_new", "educationNewList", (data) => this.form.background.push(data[5].value))
    this.getDictType("post_status", "postStatus", (data) => this.form.postStatus = data[1].value)

  },
  components: {
    listPost,
  },
  watch: {
    form: {
      handler(value) {
        console.log("form", this.form, value)
        this.key = new Date().getTime()
      },
      deep: true
    }
  },
  methods: {
    async getDictType(type, target, callback) {
      const res = await getDictType(type);
      if (res.code == 200) {
        res.data.forEach(item => {
          if (type == 'company_type') {
            this['companyType'].push({
              text: item.dictLabel,
              value: item.dictLabel,
            });
          }else{
            this[target].push({
            text: item.dictLabel,
            value: item.dictValue,
          });
          }
        
        })
        callback && callback(this[target]);
      }
    },

    handle(type, item, index, typeIndex) {
      if (['graduationYear', 'postType', 'companyType', 'background'].includes(type)) {
        this.form[type] = [item.value]
      } else {
        this.form[type] = item.value
      }
      this[typeIndex] = index;
    },
    toUrl(path) {
      if (!path) {
        Toast('功能开发中')
        return
      }

      this.$router.replace({ path })
    }
  },
};
</script>
<style scoped lang="scss">
.active {
  background: #eaf4ff;
  color: #5ca3fe;
  font-weight: bold;
}

.title {
  padding: 20px 10px;
}

.content-action {
  padding: 30px 20px;

  /deep/ .van-cell {
    margin: 6px 0px;
    border: 1px solid #ddd;
    border-radius: 10px;
  }

  .item {
    margin: 14px 0px;

    p {
      font-size: 15px;
      margin: 10px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin: 0px 4px;
        width: 80px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        background: #f5f8fa;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
